import { render, staticRenderFns } from "./TermsPop4.vue?vue&type=template&id=4ab1b7a8&"
import script from "./TermsPop4.vue?vue&type=script&lang=ts&"
export * from "./TermsPop4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports